import { render, staticRenderFns } from "./AudioSearch.vue?vue&type=template&id=15a9584c"
import script from "./AudioSearch.vue?vue&type=script&lang=js"
export * from "./AudioSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports